import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, image, path }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = origin + (path || window.location.pathname);
    const img = image
      ? image.startsWith("http")
        ? image
        : origin + image
      : origin + "/assets/wrestling-champion-raise.jpg";

    if (title) document.title = title;
    if (description) setMeta("name", "description", description);

    setMeta("property", "og:title", title || document.title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title || document.title);
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", img);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, image, path]);

  return null;
};

export default Seo;
